import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpEnableCalendar = (setIsCalendarEnabled: (val: boolean) => void) => {
    const { t } = useTranslation('newNotifications');
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);

    const exec = (rejectionReason?: string) => {
        const { exec, abort } = userApi.googleCalendarEnable({
            body: {
                rejectionReason,
            },
            onSuccess: _ => {
                toastHandler.push('success', t('googleIntegration.enableDisableCalendarTitle'), t('googleIntegration.enableCalendarSuccess'));
                setIsCalendarEnabled(true);
            },
            onError: () => toastHandler.push('error', t('googleIntegration.enableDisableCalendarTitle'), t('googleIntegration.enableCalendarError')),
        });
        exec();
        return abort;
    };
    return { exec };
};

export default useHttpEnableCalendar;
